import React from 'react'

export const Pricing = ({
    price

}) => {
    return  <span className="package-addtional-devices-price-tag" style={{fontSize: '9px'}}>
        For the selected additional device Rs.{price}/= + Taxes will be added monthly
        </span>
}